export default __webpack_public_path__ + "static/media/microscope.82c978f5.svg";